import { render } from "./InstitutionEmployees.vue?vue&type=template&id=0eb21d20&lang=pug"
import script from "./InstitutionEmployees.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionEmployees.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__